import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function ProductBundle() {
  const items = [{
    title: 'The Main eBook: THE NIGHTTIME CORTISOL CODE',
    desc: 'Cool Your Hormones and Switch Off Inflammation.'
  }, {
    title: 'The 7-Minute Protocol',
    desc: 'The exact immersion and breathing sequence to deactivate stress before your head hits the pillow.'
  }, {
    title: 'The Hormone Anchor Food List',
    desc: "Exactly what to eat for dinner so you don't wake up your insulin during the night."
  }, {
    title: 'The Self-Diagnostic Guide',
    desc: 'How to tell if your belly is driven by cortisol, inflammation, or estrogen dominance.'
  }, {
    title: 'The 21-Day Action Plan',
    desc: 'A daily calendar to move from "bloated and exhausted" to "light and renewed."'
  }];
  return <section className="bg-cream pt-10 pb-10" data-id="element-194">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-8" data-id="element-196">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-3" data-id="element-197">
            Everything Included
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold" data-id="element-198">What You Get Today</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-199">
          {/* Featured Main Item */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="md:col-span-2 bg-white p-8 rounded-3xl shadow-premium hover:shadow-premium-hover transition-shadow border border-gray-100 flex flex-col sm:flex-row items-center gap-8" data-id="element-200">
            <div className="w-32 h-32 flex-shrink-0 bg-cream rounded-2xl flex items-center justify-center p-4" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png" alt="Main eBook" className="w-full h-full object-contain drop-shadow-md" data-id="element-202" />
            </div>
            <div data-id="element-203">
              <div className="flex items-center gap-2 mb-2" data-id="element-204">
                <CheckIcon className="w-6 h-6 text-gold" data-id="element-205" />
                <h4 className="text-xl md:text-2xl font-bold text-deep-teal" data-id="element-206">
                  {items[0].title}
                </h4>
              </div>
              <p className="text-gray-600 text-lg" data-id="element-207">{items[0].desc}</p>
            </div>
          </motion.div>

          {/* Other Items */}
          {items.slice(1).map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-208">
              <div className="flex items-start gap-4" data-id="element-209">
                <div className="bg-gold/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-210">
                  <CheckIcon className="w-5 h-5 text-gold" data-id="element-211" />
                </div>
                <div data-id="element-212">
                  <h4 className="text-lg font-bold text-deep-teal mb-2" data-id="element-213">
                    {item.title}
                  </h4>
                  <p className="text-gray-600" data-id="element-214">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}